import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from "react-router-dom";
import "./index.css";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/react";
import App from "./App";

import ReactPixel from 'react-facebook-pixel';

Sentry.init({
  dsn: "https://0e7f6d0acc3f4922a695a3c525d8b9f8@o1240163.ingest.sentry.io/4504954955497472",
  integrations: [new BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      ),
  })],
  release: process.env.REACT_APP_VERSION,
  environment: process.env.REACT_APP_ENVIRONMENT,
  tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_SESSION_RATE)
});

//Facebook Pixel
const options = {
      autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
      debug: true, // enable logs
    };
ReactPixel.init('235262912304056', options);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter >
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

